/**
* oa行政资产公共form组件
* Created by zxf on 2021/04/19.
*/

<template>
  <div class="form-wrap">
    <div v-if="typeQuery === 'edit' || typeQuery === 'create'  || typeQuery === 'resubmit'"
         class="demo-ruleForm">
      <van-cell-group v-for="(item,index) in formInfo.fieldList" :key="item.id">
        <!--单行文本框-->
        <van-field
            v-model="item.fileText"
            v-if="Number(item.fieldCategory) === 10"
            :rows="3"
            :type="workflowType === 10 ? 'textarea' : 'text'"
            :label="item.fieldName+':'"
            :required="!!Number(item.fieldIsRequired)"
            :placeholder="item.fieldDesc"
            :rules="Number(item.fieldIsRequired)?
                    [{ required: true, message: `${item.fieldName}不能为空`, trigger: 'change' }]:
                    [{required: false}]"
        />
        <!--复选框-->
        <van-field name="checkboxGroup"
                   v-if="Number(item.fieldCategory) === 50"
                   :label="item.fieldName+':'"
                   :required="!!Number(item.fieldIsRequired)"
                   :rules="[{ required: !!Number(item.fieldIsRequired), message: '请至少选择一个', trigger: 'change' }]">
          <template #input>
            <van-checkbox-group v-model="item.fileText" direction="horizontal">
              <van-checkbox shape="square" :key="index"
                            :name="checkItem.label"
                            v-if="item.checkBoxList"
                            v-for="(checkItem,index) in item.checkBoxList">{{checkItem.label}}
              </van-checkbox>
            </van-checkbox-group>
          </template>
        </van-field>
        <!--单选框-->

        <van-field name="radio" :label="item.fieldName+':'"
                   v-if="Number(item.fieldCategory) === 40"
                   :required="!!Number(item.fieldIsRequired)"
                   :rules="[{ required: !!Number(item.fieldIsRequired), message: '请选择一个', trigger: 'change' }]">
          <template #input>
            <van-radio-group v-model="item.fileText" direction="horizontal">
              <van-radio :key="index"
                         :name="radioItem.label"
                         v-if="item.checkBoxList"
                         v-for="(radioItem,index) in item.checkBoxList">
                {{radioItem.label}}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <!--日期-->
        <van-cell-group v-if="Number(item.fieldCategory) === 60">
          <van-field readonly
                     clickable
                     :label="item.fieldName+':'"
                     :required="!!Number(item.fieldIsRequired)"
                     name="datetimePicker"
                     placeholder="选择日期时间"
                     :value="item.fileText"
                     @click="item.fieldFlag = !item.fieldFlag"
                     :rules="[{required: !!Number(item.fieldIsRequired), message: '请选择日期'}]">
          </van-field>
          <van-action-sheet v-model="item.fieldFlag">
            <van-datetime-picker
                :type="item.fieldDesc"
                @confirm="(values) => confirmTime(item,values)"
                @cancel="item.fieldFlag = false"
            />
          </van-action-sheet>
        </van-cell-group>
        <!--图片-->
        <van-field name="uploader"
                   v-if="Number(item.fieldCategory) === 20"
                   :label="item.fieldName+':'"
                   :required="!!Number(item.fieldIsRequired)"
                   :rules="Number(item.fieldIsRequired)?
                             [{ required: true, message: '请上传图片', trigger: 'change' }]:[{required: false}]">
          <template #input>
            <van-uploader v-model="item.fileText"
                          v-show="false" multiple/>
            <div class="spu-pic-info"
                 v-if="item.fileText.length >= 1">
              <div class="image-list"
                   :key="index"
                   v-for="(img,index) in item.fileText">
                <el-image :src="img"
                          :z-index="3000"
                          lazy
                          :preview-src-list="item.fileText">
                </el-image>
                <!--删除按钮-->
                <div class="close-icon" @click="delImage('', index,item.id)">
                  <i class="iconfont">&#xe7c1;</i>
                </div>
              </div>
              <van-uploader :after-read="(file) => afterRead(file,item)" multiple/>
            </div>
            <van-uploader v-else
                          :after-read="(file) => afterRead(file,item)" multiple/>
          </template>
        </van-field>
        <!--文件-->
        <van-field name="uploader"
                   :label="item.fieldName+':'"
                   :required="!!Number(item.fieldIsRequired)"
                   v-if="Number(item.fieldCategory) === 30"
                   :rules="Number(item.fieldIsRequired)?
                             [{ required: true, message: '请上传附件', trigger: 'change' }]:[{required: false}]">
          <template #input>
            <van-uploader v-model="item.filedArr"
                          v-show="false" multiple/>
            <van-tag v-if="item.filedInfo" closeable size="medium" type="primary" @close="handleClose(item.id)">
              <el-link :underline="false"
                       class="accessory"
                       :href="item.filedInfo" target="_blank">
                {{item.filedName}}
              </el-link>
            </van-tag>
            <van-uploader accept="*" v-else :after-read="(file) => afterReadField(file,item)" :max-count="1">
              <van-button icon="plus" size="small" native-type="button" type="info">上传文件</van-button>
            </van-uploader>
            <div class="warning">&nbsp&nbsp&nbsp(不得大于10M)</div>
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group class="auditConfig-list">
        <van-field readonly label="审批人:">
          <template #right-icon v-if="!auditPerson">
            <div class="add-carbon-copy-recipients" @click="addAudit('auditPersons')">
              <i class="iconfont">&#xe905;</i>
            </div>
          </template>
          <template #input>
            <div class="block">
              <div class="add-wrap" v-if="!auditPerson">
                <div class="person-wrap">
                  <div class="person-block" v-if="!!addAssetDate.myAuditConfig">
                    <div class="person"
                         :key="index"
                         v-if="!!addAssetDate.myAuditConfig"
                         v-for="(approver,index) in addAssetDate.myAuditConfig.auditUsers">
                      <div class="person-name">
                        {{approver.userName}}
                      </div>
                      <!--删除按钮-->
                      <div class="close-icon" @click="deleteUser(approver,'auditUsers')">
                        <i class="iconfont"
                           title="删除">&#xe7c1;</i>
                      </div>
                    </div>
                  </div>
                  <div class="person"
                       :key="approver.userId"
                       v-for="(approver,index) in formInfo.auditInfo.auditUsers">
                    <div class="person-name">
                      {{approver.userName}}
                    </div>
                    <!--删除按钮-->
                    <div class="close-icon" @click="deleteUser(approver,'auditUsers', true)">
                      <i class="iconfont">&#xe7c1;</i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="all-person" v-else>
                全部
              </div>
            </div>
          </template>
        </van-field>

        <van-field readonly label="抄送人:">
          <template #right-icon v-if="!ccPerson">
            <div class="add-carbon-copy-recipients" @click="addAudit('ccPersons')">
              <i class="iconfont">&#xe905;</i>
            </div>
          </template>
          <template #input>
            <div class="block">
              <div class="add-wrap" v-if="!ccPerson">
                <div class="person-wrap">
                  <div class="person-block" v-if="!!addAssetDate.myAuditConfig">
                    <div class="person"
                         :key="approver.userId"
                         v-for="(approver,index) in addAssetDate.myAuditConfig.ccUsers">
                      <div class="person-name">
                        {{approver.userName}}
                      </div>
                      <!--删除按钮-->
                      <div class="close-icon" @click="deleteUser(approver,'ccUsers')">
                        <i class="iconfont">&#xe7c1;</i>
                      </div>
                    </div>
                  </div>
                  <div class="person"
                       :key="approver.userId"
                       v-if="formInfo.auditInfo.ccUsers"
                       v-for="(approver,index) in formInfo.auditInfo.ccUsers">
                    <div class="person-name">
                      {{approver.userName}}
                    </div>
                    <!--删除按钮-->
                    <div class="close-icon" @click="deleteUser(approver,'ccUsers', true)">
                      <i class="iconfont">&#xe7c1;</i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="all-person" v-else>
                全部
              </div>
            </div>
          </template>
        </van-field>
      </van-cell-group>

      <!-- <van-cell-group label-width="1.2rem" class="form-btn">
         &lt;!&ndash; @click.prevent="submitForm"&ndash;&gt;
         &lt;!&ndash;提交触发  procurement.vue 里的 onSubmit（触发条件，表单验证通过 否则） 然后触发 create里的onSubmit进行表单提交&ndash;&gt;
         <van-button type="info">提交</van-button>
         <van-button @click.prevent="resetForm">取消</van-button>
       </van-cell-group>-->
    </div>
    <div v-if="typeQuery === 'view' || typeQuery === 'approval'"
         class="demo-ruleForm">
      <van-cell-group v-for="(item,index) in formInfo.fieldList" :key="item.id">
        <!--单行文本框-->
        <van-field
            v-if="Number(item.fieldCategory) === 10"
            readonly
            :rows="3"
            :type="workflowType === 10 ? 'textarea' : 'text'"
            :label="item.fieldName+':'"
        >
          <template #input>
            <div v-html="item.fileText"></div>
          </template>
        </van-field>
        <!--复选框-->
        <van-field v-if="Number(item.fieldCategory) === 50"
                   :label="item.fieldName+':'">
          <template #input>
            <el-tag class="accessory-tag"
                    :key="index"
                    v-for="(check,index) in item.fileText">
              {{check | checkNull()}}
            </el-tag>
          </template>
        </van-field>
        <!--单选框-->

        <van-field :label="item.fieldName+':'"
                   v-if="Number(item.fieldCategory) === 40">
          <template #input>
            {{item.fileText | checkNull()}}
          </template>
        </van-field>
        <!--日期-->
        <van-cell-group v-if="Number(item.fieldCategory) === 60">
          <van-field readonly
                     :label="item.fieldName+':'"
                     name="datetimePicker"
                     :value="item.fileText">
          </van-field>
        </van-cell-group>
        <!--图片-->
        <van-field v-if="Number(item.fieldCategory) === 20"
                   :label="item.fieldName+':'">
          <template #input>
            <div class="spu-pic-info">
              <div class="image-list"
                   v-if="item.fileText.length >= 1"
                   :key="index"
                   v-for="(img,index) in item.fileText">
                <el-image :src="img"
                          :z-index="3000"
                          lazy
                          :preview-src-list="item.fileText">
                </el-image>
              </div>
            </div>
          </template>
        </van-field>
        <!--文件-->
        <van-field name="uploader"
                   :label="item.fieldName+':'"
                   v-if="Number(item.fieldCategory) === 30">
          <template #input>
            <van-tag v-if="item.filedInfo" size="medium" type="primary">
              <el-link :underline="false"
                       class="accessory"
                       :href="item.filedInfo" target="_blank">
                {{item.filedName}}
              </el-link>
            </van-tag>
          </template>
        </van-field>
      </van-cell-group>
      <van-cell-group class="auditConfig-list">
        <van-field readonly label="审批人:">
          <template #input>
            <div class="block">
              <div class="add-wrap" v-if="formInfo.auditInfo.auditUsers.length !== parallelData.length">
                <div class="person-wrap">
                  <div class="person-arrow-wrap"
                       :key="approver.userId"
                       v-for="(approver,index) in formInfo.auditInfo.auditUsers">
                    <div class="person"
                         :class="
                           {
                              'approver-success' :
                              (approver.auditResult === 30 || approver.auditResult === 50) && !journalFlag,
                              'approver-reject' : approver.auditResult === 40 && !journalFlag,
                              'approver-wait' : approver.auditResult === 20 && !journalFlag
                          }">
                      <div class="person-name">
                        {{approver.userName}}
                      </div>
                    </div>
                    <div class="person-arrow"
                         v-if="((typeQuery === 'view' || typeQuery === 'approval') &&
                                (addAssetDate.myAuditConfig &&
                                addAssetDate.myAuditConfig.auditCategory === 10)) &&
                                !journalFlag &&
                                formInfo.auditInfo.auditUsers.length - 1 !== index">
                      <i class="iconfont">&#xe9e6;</i>
                    </div>
                  </div>

                </div>
              </div>
              <div class="all-person" v-else>
                全部
              </div>
            </div>
          </template>
        </van-field>

        <van-field readonly label="抄送人:">
          <template #input>
            <div class="block">
              <div class="add-wrap" v-if="formInfo.auditInfo.ccUsers.length !== parallelData.length">
                <div class="person-wrap">
                  <div class="person"
                       :key="approver.userId"
                       v-if="formInfo.auditInfo.ccUsers"
                       v-for="(approver,index) in formInfo.auditInfo.ccUsers">
                    <div class="person-name">
                      {{approver.userName}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="all-person" v-else>
                全部
              </div>
            </div>
          </template>
        </van-field>
      </van-cell-group>

      <van-cell-group class="form-btn" v-if="typeQuery === 'approval'">
        <!-- @click.prevent="submitForm"-->
        <!--提交触发  procurement.vue 里的 onSubmit（触发条件，表单验证通过 否则） 然后触发 create里的onSubmit进行表单提交-->
        <van-button type="info" @click.prevent="submitForm">同意</van-button>
        <van-button @click.prevent="promptlyApprove">拒绝</van-button>
      </van-cell-group>

    </div>
    <!--添加审批人 抄送人的弹出框-->
    <van-popup
        v-model="addAuditCCDialog"
        position="right"
        @close="closeAudit"
        :close-on-click-modal="false"
        :title="`添加${dialogName}`"
        :style="{ height: '100%', width: '100%'}"
        class="supplier-channel-dialog"
    >
      <!-- <el-cascader-panel
           class="auditUserPerson"
           v-model="personChoose"
           :key="keyValue"
           show-all-levels
           clearable
           size="medium"
           :props="{ multiple: true }"
           :options="approver"></el-cascader-panel>-->
      <!--{{companyPersonList}}-->
      <van-nav-bar :title="`添加${dialogName}`"
                   :border="false"
                   @click-left="clickNav"
                   left-text="返回" left-arrow></van-nav-bar>
      <div class="header-crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item @click.native="breadcrumbChange(item,index)"
                              :class="item.currentIndex === index ? 'active-breadcrumb' : ''"
                              :key="index"
                              v-for="(item,index) in companyPersonBreadcrumb">{{item.betName}}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-wrap">
        <van-cell-group v-if="checkAllDisabled" class="check-all">
          <van-cell-group>
            <van-cell class="supplier-channel-dialog-cell" clickable @click="checkAllPerson">
              全部人员
              <template #right-icon>
                <van-checkbox
                    v-model="checkAll"
                    icon-size="0.18rem"/>
              </template>
            </van-cell>
          </van-cell-group>
        </van-cell-group>
        <div class="title" v-if="companyPersonList[0] && companyPersonList[0].sonListBlock">部门</div>
        <van-cell-group class="supplier-channel-first-group" v-if="companyPersonList[0] && companyPersonList[0].sonListBlock">
          <van-cell class="supplier-channel-dialog-cell" v-if="item.sonListBlock"
                    :key="item.id" v-for="item in companyPersonList">
            <template #title>
              <div class="title-wrap">
                <span class="custom-title">{{item.deptName}}</span>
              </div>
            </template>
            <template #right-icon>
              <div class="next-department" @click="nextDepartment(item)">
                <van-icon class="iconfont">&#xe9e3;</van-icon>
                <span>下级</span>
              </div>
            </template>
          </van-cell>
          <van-empty
              v-else
              class="custom-image"
              image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
              description="暂无下级部门"
          />
        </van-cell-group>
        <div class="title">人员</div>
        <van-cell-group>
          <div v-if="!!companyPersonList.preDepartment">
            <van-checkbox-group v-model="checkPerson"
                                :key="person.userId"
                                v-for="(person,index) in companyPersonList.preDepartment"
                                class="person-cell-radio">
              <van-cell-group>
                <van-cell class="supplier-channel-dialog-cell" clickable @click="toggle(index,person.radio)">
                  <div class="auditConfig-list">
                    <div class="person-name">
                      {{person.bizName}}
                    </div>
                  </div>
                  <template #right-icon>
                    <van-checkbox :name="person.userId"
                                  ref="checkboxes"
                                  :label-disabled="person.radio"
                                  icon-size="0.18rem" :disabled="person.radio"/>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
          <van-empty
              v-else
              class="custom-image"
              image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
              description="暂无人员"
          />
        </van-cell-group>
      </div>
      <div class="footer-wrap">
        <div class="select-person">
          <div class="select-wrap" @click="addAuditCCDialogInner = true">
            <div class="select-tit">已选择：{{personNum}}人</div>
            <div class="person-name-wrap">
              {{personName}}
            </div>
          </div>
          <van-action-sheet heigth="60%" v-model="addAuditCCDialogInner" :title="`已选择：${personNum}人`">
            <van-cell-group :key="item.userId"
                            v-for="(item,index) in personNameCell">
              <van-cell class="supplier-channel-dialog-cell">

                <div class="person-tit">
                  {{item.userName}}
                </div>
                <template #right-icon>
                  <van-button size="small" :disabled="item.disabled"
                              @click="delPerson(item)"
                              type="default">移除
                  </van-button>
                </template>
              </van-cell>
            </van-cell-group>
          </van-action-sheet>
        </div>
        <el-button type="primary" @click="sumitCascader">确定</el-button>
      </div>
    </van-popup>
    <!--立即审批弹出框-->
    <van-popup v-model="approveDialog"
               round
               closeable
               :style="{width: '80%'}"
               class="approve-dialog">
      <van-form @failed="onFailed"
                :key="formKey"
                @submit="rejectForm">
        <van-field>
          <template #input>
            <div class="title-wrap">
              <span v-for="(item,index) in approveForm.title" :key="index">{{item}}</span>
            </div>
          </template>
        </van-field>

        <van-field label="拒绝原因:"
                   placeholder="请填写拒绝原因"
                   required
                   v-model="approveForm.rejRank"
                   :rules="[{ required: true, message: '拒绝请填写原因', trigger: 'change' }]"/>
        <br>
        <van-cell-group class="approve-bth-wrap">
          <van-button size="small" type="danger">拒绝</van-button>
        </van-cell-group>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  let _ = require('lodash')
  export default {
    name: 'assetForm-index',
    props: {
      typeQuery: {
        type: String,
        default: ''
      },
      addAssetDate: {
        type: Object,
        default: {}
      },
      type: {
        type: String,
        default: ''
      },
      assetsProcurementDate: {
        type: Array,
        default: []
      },
      singleList: {
        type: Array,
        default: []
      },
      dateNameList: {
        type: Array,
        default: []
      },
      //工作流类型
      workflowType: {
        type: Number,
        default: 0
      },
      //采购价格
      procurementPrice: {
        type: Boolean,
        default: false
      },
      //工作流详情
      valueDetailsList: {
        type: Object,
        default: null
      },
      //工作流ID
      workId: {
        type: Number,
        default: null
      },
      //判断是否是日志工作流
      journalFlag: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        //van-form的formKey值  用来清除表单验证
        formKey: 0,
        //控制立即审批是否显示
        approveDialog: false,
        //列表名
        listName: '',
        //控制全选按钮是否出现
        checkAllDisabled: true,
        //全选
        checkAll: false,
        //模板初始人员
        templateInitPerson: [],
        //内部弹出框
        addAuditCCDialogInner: false,
        //选中的人员
        checkPerson: [],
        //公司人员列表面包屑
        companyPersonBreadcrumb: [
          {
            betName: '通讯录',
            currentIndex: 0
          }
        ],
        //公司人员列表
        companyPersonList: [],
        //公司人员默认列表
        defaultCompanyPersonList: [],
        //审批人全部按钮
        auditPerson: false,
        //抄送人全部按钮
        ccPerson: false,
        //dialog的名字
        dialogName: '',
        //解决el-cascader-panel报错
        keyValue: 1,
        //模板自带人员的数据
        personInfo: [],
        //所有部门人员的平行数据
        parallelData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        //添加审批抄送人员dialog
        addAuditCCDialog: false,
        //图片对应的Id
        imgId: '',
        imgFlag: '',
        formInfo: {
          //数据
          fieldList: [],
          //审批数据(渲染的新增的审批或者抄送人员)
          auditInfo: {
            auditUsers: [],
            ccUsers: []
          },
          //我的审批1
          myAuditConfig: [],
          //我的审批2
          myAuditConfigSecond: [],
          //审批人员（不带模板自带的）
          auditPersons: [],
          //抄送人员（不带模板自带的）
          ccPersons: [],
        },
        //抄送人
        CCTo: [
          {
            value: '',
            label: '全部',
          }
        ],
        //人员选择
        personChoose: '',
        //审批人
        approver: [
          {
            value: '',
            label: '全部',
          }
        ],
      }
    },
    watch: {
      approver: {
        handler() {
          this.keyValue++
        },
        deep: true
      },
    },
    computed: {
      personNum: function () {
        return this.checkPerson.length
      },
      personName: function () {
        let arr = [], list = this.parallelData, ids = this.checkPerson
        if (ids && ids.length > 0) {
          ids.forEach(item => {
            list.forEach(person => {
              if (person.value === item){
                arr.push(person.label)
              }
            })
          })
          //这种方法选中顺序会按照list 的来
          /*arr = list
            .filter(item => ids.indexOf(item.value) > -1)
            .map(item => item.label)*/
        }
        return arr.join('、')
      },
      personNameCell: function () {
        let arr = [], list = this.parallelData, ids = this.checkPerson
        if (ids && ids.length > 0) {
          ids.forEach(item => {
            list.forEach(person => {
              if (person.value === item){
                let obj = {
                  userName: person.label,
                  userId: person.value,
                  disabled: person.disabled
                }
                arr.push(obj)
              }
            })
          })
          //这种方法选中顺序会按照list 的来
          /* arr = list
             .filter(item => ids.indexOf(item.value) > -1)
             .map(item => {
               let obj = {
                 userName: item.label,
                 userId: item.value,
                 disabled: item.disabled
               }
               return obj
             })*/
        }
        return arr
      },
      ...mapState('officeAutomation', ['approveForm'])
    },
    methods: {

      //审批表单验证
      onFailed(values) {
        this.$toast.fail(values.errors[0].message)
      },
      //审批通过
      submitForm() {
        let obj = {
          workflowId: this.valueDetailsList.id,
          auditPass: true
        }
        //加载中
        let loading = this.$loading({'target': 'body'})
        this.$httpV3.post('oa/workflow/audit', obj)
          .then(res => {
            loading.close()
            if (Number(res.data.code) === 10000) {
              this.$toast.success('审批成功')
              this.successGoList()
            } else {
              this.$toast.fail(res.data.msg)
            }
          })
          .catch(rej => {
            loading.close()
          })
      },
      //审批拒绝
      rejectForm() {
        let obj = {
          workflowId: this.approveForm.id,
          auditPass: false,
          auditContent: this.approveForm.rejRank
        }
        this.$httpV3.post('oa/workflow/audit', obj)
          .then(res => {
            if (Number(res.data.code) === 10000) {
              this.$toast.success('申请已拒绝')
              this.approveDialog = false
              this.successGoList()
            } else {
              this.$toast.fail(res.data.msg)
            }
          })
      },
      //立即审批
      promptlyApprove() {
        this.formKey++
        this.approveDialog = true
      },
      //全选
      checkAllPerson() {
        if (this.checkAll) {
          this.checkPerson = this.templateInitPerson
        } else {
          this.checkPerson = this.parallelData.map(item => item.value)
        }
        this.checkAll = !this.checkAll
      },
      //移除人员
      delPerson(item) {
        this.checkPerson = this.checkPerson.filter(check => check !== item.userId)
      },
      toggle(index, flag = false) {
        if (!flag) {
          this.$refs.checkboxes[index].toggle();
        } else {
          this.$toast.fail('基础模板配置人员不能取消')
        }
      },
      //点击返回
      clickNav() {
        this.addAuditCCDialog = false
      },
      //切换面包屑递归
      breadcrumbSearch(list, obj, i) {
        list.forEach((item, index) => {
          if (item.id === obj.id && item.level === i && item.sonList) {
            this.companyPersonList = item.sonList
            this.companyPersonList.forEach(son => {
              son.sonListBlock = true
            })
            this.companyPersonList.preDepartment = item.companyUserList
            this.companyPersonBreadcrumb.splice(i + 1)
            this.companyPersonBreadcrumb.forEach(company => {
              company.currentIndex = i
            })
          } else {
            if (item.sonList) {
              this.breadcrumbSearch(item.sonList, obj, i)
            }
          }
        })
      },
      //切换面包屑
      breadcrumbChange(item, i) {
        if (item.betName === '通讯录') {
          this.checkAllDisabled = true
          this.companyPersonList = this.Unbind(this.defaultCompanyPersonList)
          this.companyPersonList.forEach(item => {
            item.sonListBlock = true
          })
          this.companyPersonBreadcrumb = [
            {
              betName: '通讯录',
              currentIndex: 0
            }
          ]
          this.companyPersonList.preDepartment = this.parallelData.map(item => {
            let obj = {
              bizName: item.label,
              userId: item.value
            }
            if (item.disabled === true){
              obj.radio = true
            }
            return obj
          })
        } else {
          this.checkAllDisabled = false
          this.breadcrumbSearch(this.defaultCompanyPersonList, item, i)
        }
      },
      //点击进入下一级部门
      nextDepartment(item) {
        this.checkAllDisabled = false
        if (item.sonList) {
          this.companyPersonList = item.sonList
          this.companyPersonList.preDepartment = item.companyUserList
          console.log(this.companyPersonList.preDepartment)
          this.companyPersonList.forEach(son => {
            son.sonListBlock = true
            /*son.preDepartment = item.companyUserList*/
          })
        } else {
          this.companyPersonList = [item]

          this.companyPersonList.preDepartment = item.companyUserList
          this.companyPersonList.forEach(son => {
            son.sonListBlock = false
          })
        }
        //改变面包屑导航数据
        let obj = {
          betName: item.deptName,
          id: item.id,
        }
        this.companyPersonBreadcrumb.push(obj)
        this.companyPersonBreadcrumb.forEach(company => {
          company.currentIndex = item.level
        })
      },
      //批量上传图片合集
      afterRead(file, item) {
        if (file.length) {
          this.uploadUploadList(file, item)
        } else {
          this.uploadUploadList([file], item)
        }

      },
      //上传附件
      afterReadField(file, item) {
        this.uploadUpload(file, item)
      },
      //确定时间
      confirmTime(item, values) {
        if (item) {
          if (item.fieldDesc === 'date') {
            item.fileText = new Date(values).getTime().toString().timeStampFormat('yyyy-MM-dd')
          } else {
            item.fileText = new Date(values).getTime().toString().timeStampFormat()
          }
        }
        item.fieldFlag = false
      },
      //提交添加审批||抄送人员
      /**
       * type: 不带模板的
       * typeInfo： 模板的
       * */
      sumitCascader() {

        let type, typeInfo, myAuditObj = [], arr2 = [], arr1 = [], arr = []
        if (this.dialogName === '审批人') {
          type = 'auditPersons'
          typeInfo = 'auditUsers'
        } else if (this.dialogName === '抄送人') {
          type = 'ccPersons'
          typeInfo = 'ccUsers'
        }
        if (this.addAssetDate.myAuditConfig && this.addAssetDate.myAuditConfig[typeInfo]) {
          this.addAssetDate.myAuditConfig[typeInfo].forEach(item => {
            arr2.push(item.userId)
          })
        }
        this.checkPerson.forEach(item => {
          arr1.push(item)
        })
        //数组去重
        if (arr2.length > 0) {
          let arrBoth = _.xor(arr2, arr1)
          arrBoth.forEach(item => {
            this.parallelData.forEach(parallel => {
              if (item === parallel.value) {
                let obj = {
                  userName: parallel.label,
                  userId: parallel.value
                }
                arr.push(obj)
              }
            })
          })
        } else {
          arr1.forEach(item => {
            this.parallelData.forEach(parallel => {
              if (item === parallel.value) {
                let obj = {
                  userName: parallel.label,
                  userId: parallel.value
                }
                arr.push(obj)
              }
            })
          })
        }
        this.formInfo[type] = arr
        this.formInfo[type].forEach(item => {
          myAuditObj.push(item)
        })
        this.formInfo.auditInfo[typeInfo] = myAuditObj
        this.addAuditCCDialog = false
      },
      //删除审批||抄送人员 type 'ccUsers' 抄送人删除 'auditUsers' 审批人删除 flag ： true 新增人员 false 模板基础人员（不可删）
      deleteUser(person, type, flag = false) {
        if (flag) {
          this.formInfo.auditInfo[type] = this.formInfo.auditInfo[type].filter(item => item.userId !== person.userId)
          this.checkPerson = this.checkPerson.filter(item => item !== person.userId)
          this.checkAll = false
        } else {
          if (this.addAssetDate.myAuditConfig[type]) {
            this.addAssetDate.myAuditConfig[type].forEach(item => {
              if (person.userId === item.userId) {
                switch (type) {
                  case 'ccUsers':
                    this.$toast.fail(`不能删除模板中的基础抄送人`)
                    break
                  case 'auditUsers':
                    this.$toast.fail(`不能删除模板中的基础审批人`)
                    break
                }
              }
            })
          }
        }

      },
      //关闭添加审批&抄送触发
      closeAudit() {
        this.parallelData.forEach(item => {
          item.disabled = false
        })
        this.addAuditCCDialog = false
      },
      //添加审批人
      addAudit(type, i) {
        //选中数据初始化
        this.checkAllDisabled = true
        this.checkPerson = []
        if (type === 'auditPersons') {
          this.handleInfo('auditUsers', i, type)
          this.dialogName = '审批人'
        } else if (type === 'ccPersons') {
          this.handleInfo('ccUsers', i, type)
          this.dialogName = '抄送人'
        }
        //面包屑导航初始化
        this.companyPersonBreadcrumb = [
          {
            betName: '通讯录',
            currentIndex: 0
          }
        ]
        //数据初始化
        this.companyPersonList = this.Unbind(this.defaultCompanyPersonList)
        this.companyPersonList.preDepartment = this.parallelData.map(item => {
          let obj = {
            bizName: item.label,
            userId: item.value
          }
          if (item.disabled === true){
            obj.radio = true
          }
          return obj
        })
        this.addAuditCCDialog = true
      },
      //递归比较人员
      recursionPerson(list, user, flag = false) {
        list.forEach(item => {
          if (item.companyUserList) {
            item.companyUserList.forEach(company => {
              if (company.userId === user.userId) {
                this.checkPerson.push(user.userId)
                company.radio = flag
              }
            })
          }
          if (item.sonList) {
            this.recursionPerson(item.sonList, user, flag)
          } else {
            return false
          }
        })
      },
      //处理审批人抄送人数据
      handleInfo(type, i, infoType) {
        if (this.addAssetDate.myAuditConfig && this.addAssetDate.myAuditConfig[type]) {
          this.personInfo = []
          this.addAssetDate.myAuditConfig[type].forEach((apply, index) => {
            this.getPersonDate(apply.userId, true)
            this.templateInitPerson.push(apply.userId)
            this.recursionPerson(this.companyPersonList, apply, true)
            this.recursionPerson(this.defaultCompanyPersonList, apply, true)
          })
        }

        if (this.formInfo.auditInfo[type]) {
          this.formInfo.auditInfo[type].forEach((apply, index) => {
            this.checkPerson.push(apply.userId)
          })
        }
        //数组去重
        this.checkPerson = [...new Set(this.checkPerson)]
        this.templateInitPerson = [...new Set(this.templateInitPerson)]
        this.checkPerson.forEach((item) => {

          this.getPersonDate(item)
        })

      },
      errorHandler() {
        return true
      },
      //删除附件
      handleClose(id) {
        this.formInfo.fieldList.forEach(item => {
          if (id === item.id) {
            item.filedInfo = ''
            item.filedName = ''
            item.filedSize = ''
            item.filedArr = []
          }
        })
      },
      //上传
      uploadUpload(field, item) {
        let file = field.file
        if (!file) {
          return false
        }

        //文件大小验证
        let fileSize = this.validateFileSize(file, '10MB')
        if (!fileSize) {
          return false
        }

        //文件类型验证
        let fileType = this.validateFileType(file.name, '')
        if (!fileType) {
          return false
        }

        //对象存储上传文件
        this.$uploadFile(file, (data) => {
          if (data.code) {
            this.$toast.fail(data.msg)
          } else {
            item.filedInfo = data.fileUrl
            item.filedName = data.fileName
            item.filedSize = data.fileSize
            item.filedArr.push(item.filedInfo)
          }
        })
      },
      //上传图片合集
      uploadUploadList(fileList, item) {
        let loading = true
        let files = []
        fileList.forEach(list => {
          files.push(list.file)
        })
        if (files.length === 0) {
          return false
        }

        if (files.length > 200) {
          this.$toast.fail(`${item.fieldName}每次最多上传20张`)
          return false
        }

        let totalSize = 0
        for (let i = 0; i < files.length; i++) {
          let file = files[i]

          //文件大小验证
          let fileSize = this.validateFileSize(file, '5MB')
          if (!fileSize) {
            return false
          }

          //文件类型验证
          let fileType = this.validateFileType(file.name)
          if (!fileType) {
            return false
          }

          //获取总重量
          totalSize += file.size
        }

        if (!this.validateFileSize({size: totalSize}, '100MB', '单次提交文件大小总和请勿超过100MB')) {
          return false
        }
        this.$uploadFileBatch(files, (data) => {

          fileList.forEach((field, index) => {
            item.fileText.push(data[index].fileUrl)
          })
          item.imgDesc = item.fileText
          this.$forceUpdate()
        })

      },
      //删除图片
      delImage(file, index, id) {
        let i = index
        this.formInfo.fieldList.forEach(item => {
          if (item.id === id) {
            item.fileText = item.fileText.filter((img, index) => i !== index)
            //表单验证需要以下
            item.imgDesc = item.imgDesc.filter((img, index) => i !== index)
            this.$forceUpdate()
          }
        })
      },
      //初始化数据
      initAssetData() {
        this.formInfo.fieldList = this.addAssetDate.fieldList
        this.formInfo.fieldList.forEach(item => {
          let arr = []
          if (Number(item.fieldCategory) === 40 || Number(item.fieldCategory) === 50) {
            if (typeof item.fieldSelectorConfig === 'string') {
              JSON.parse(item.fieldSelectorConfig).forEach(field => {
                let obj = {
                  label: field
                }
                arr.push(obj)
              })
              item.checkBoxList = arr
            }
          }
          switch (Number(item.fieldCategory)) {
            case 10:
              this.$set(item, 'fileText', '')
              break
            case 20:
              this.$set(item, 'fileText', [])
              this.$set(item, 'imgDesc', '')
              break
            case 30:
              this.$set(item, 'filedInfo', '')
              this.$set(item, 'filedName', '')
              this.$set(item, 'filedSize', '')
              this.$set(item,'filedArr',[])
              break
            case 40:
              this.$set(item, 'fileText', '')
              break
            case 50:
              this.$set(item, 'fileText', [])
              break
            case 60:
              this.$set(item, 'fileText', '')
              this.$set(item, 'fieldFlag', false)
              break
          }
        })
        if (this.addAssetDate.myAuditConfig) {
          if (this.addAssetDate.myAuditConfig.auditUsers) {
            if (this.addAssetDate.myAuditConfig.auditUsers.length === this.parallelData.length) {
              this.auditPerson = true
            } else {
              this.auditPerson = false
            }
          }
          if (this.addAssetDate.myAuditConfig.ccUsers) {
            if (this.addAssetDate.myAuditConfig.ccUsers.length === this.parallelData.length) {
              this.ccPerson = true
            } else {
              this.auditPerson = false
            }
          }
        }

      },
      /* //处理工作流字段的数据
       handleFiled(templateObj, type, flag = '') {
         if (this.formInfo[type].length > 0) {
           let checkData = this.Unbind(this.formInfo[type])
           checkData.forEach(item => {
             let filedDataObj = {
               fieldValue: item.fileText,
               workflowTemplateFieldId: item.id
             }
             if (flag === 'filed') {
               filedDataObj.fieldValue = JSON.stringify({
                 fileName: item.filedName,
                 fileUrl: item.filedInfo,
                 fileSize: item.filedSize
               })
             }
             if (this.workflowType === 10) {
               if (type === 'singleText') {
                 //替换所有的换行符
                 let string = filedDataObj.fieldValue
                 string = string.replace(/\r\n/g, '<br>')
                 string = string.replace(/\n/g, '<br>')
                 //替换所有的空格（中文空格、英文空格都会被替换）
                 filedDataObj.fieldValue = string.replace(/\s/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
               }
             }
             if (flag === 'check' || flag === 'img') {
               filedDataObj.fieldValue = JSON.stringify(item.fileText)
             }
             if (flag === 'date') {
               if (item.fileText) {
                 filedDataObj.fieldValue = new Date(item.fileText).getTime()
               }
             }
             templateObj.valueList.push(filedDataObj)
           })
         }
       },*/


      //提交处理
      handleFormInfo() {
        let templateObj = {
          workflowTemplateId: Number(this.$route.query.templateId),
          valueList: [],
          auditUserList: [],
          ccUserList: [],
          itemList: []
        }
        let checkData = this.Unbind(this.formInfo.fieldList)

        checkData.forEach(item =>  {
          let filedDataObj = {
            fieldValue: '',
            workflowTemplateFieldId: item.id
          }
          if (Number(this.workflowType) === 10) {
            if (Number(item.fieldCategory) === 10) {
              //替换所有的换行符
              let string = item.fileText
              string = string.replace(/\r\n/g, '<br>')
              string = string.replace(/\n/g, '<br>')
              //替换所有的空格（中文空格、英文空格都会被替换）
              item.fileText = string.replace(/\s/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
            }
          }
          switch (Number(item.fieldCategory)) {
            case 10:
              if (item.fileText){
                filedDataObj.fieldValue = item.fileText
              }
              break;
            case 20:
              if (item.fileText && item.fileText.length > 0) {
                filedDataObj.fieldValue = JSON.stringify(item.fileText)
              }
              break
            case 30:
              if (item.filedName && item.filedInfo && item.filedSize){
                filedDataObj.fieldValue = JSON.stringify({
                  fileName: item.filedName,
                  fileUrl: item.filedInfo,
                  fileSize: item.filedSize
                })
              }
              break
            case 40:
              if (item.fileText){
                filedDataObj.fieldValue = item.fileText
              }
              break;
            case 50:
              if (item.fileText && item.fileText.length > 0) {
                filedDataObj.fieldValue = JSON.stringify(item.fileText)
              }
              break
            case 60:
              if (item.fileText) {
                filedDataObj.fieldValue = new Date(item.fileText.replace(/-/g,'/')).getTime()
              }
              break
          }
          if (filedDataObj.fieldValue){
            templateObj.valueList.push(filedDataObj)
          }
        })
        if (this.addAssetDate.myAuditConfig) {
          if (this.addAssetDate.myAuditConfig.auditUsers) {
            this.addAssetDate.myAuditConfig.auditUsers.forEach(item => {
              let obj = {
                auditUserId: item.userId
              }
              templateObj.auditUserList.push(obj)
            })
          }
          if (this.addAssetDate.myAuditConfig.ccUsers) {
            this.addAssetDate.myAuditConfig.ccUsers.forEach(item => {
              let obj = {
                ccUserId: item.userId
              }
              templateObj.ccUserList.push(obj)
            })
          }
        }

        this.formInfo.auditInfo.auditUsers.forEach(item => {
          let obj = {
            auditUserId: item.userId
          }
          templateObj.auditUserList.push(obj)
        })
        this.formInfo.auditInfo.ccUsers.forEach(item => {
          let obj = {
            ccUserId: item.userId
          }
          templateObj.ccUserList.push(obj)
        })
        this.assetsProcurementDate.forEach(item => {
          let listObj = {
            //资产配置
            asset: Number(this.workflowType) === 20 ? {
              //资产数量
              assetChangeQuantity: item.assetNum,
              assetId: item.assetObj.assetName,
              purchasePrice: this.procurementPrice ? this.accMul(item.purchasePrice, 100) : null
            } : null,
            //财务配置
            finance: Number(this.workflowType) === 30 ? {
              amountChangeQuantity: this.accMul(item.amountChangeQuantity, 100)
            } : null,
            //子项字段值
            valueList: []
          }
          if (item.singList) {
            item.singList.forEach((single, index) => {
              let obj = {
                fieldValue: item['file' + index],
                workflowTemplateFieldId: item['singId' + index]
              }
              listObj.valueList.push(obj)
            })
          }

          if (item.dateList) {
            item.dateList.forEach((date, index) => {
              let obj = {
                // fieldValue: new Date(item['oldDate' + index]).getTime(),
                //.replace(/-/g,'/')
                // 兼容ios   ios不支持new Date() 参数是时间格式的字符串（类似于2011-01-01 00:00:00）这种要用 .replace(/-/g,'/') 转换一下
                fieldValue: new Date(item['oldDate' + index].replace(/-/g,'/')).getTime(),
                workflowTemplateFieldId: item['dateId' + index]
              }
              listObj.valueList.push(obj)
            })
          }
          templateObj.itemList.push(listObj)
        })
        let url = 'oa/workflow/insert'
        if (this.typeQuery === 'resubmit' || this.typeQuery === 'edit') {
          templateObj.id = this.workId
          url = 'oa/workflow/revokeAndInsert'
        }
        let loading = this.$loading({'target': 'body'})
        this.$httpV3.post(url, templateObj)
          .then(res => {
            loading.close()
            if (Number(res.data.code) === 10000) {
              this.$toast.success('提交成功')
              this.successGoList()
            } else {
              this.$toast.fail(res.data.msg)
            }
          })
          .catch(rej => {
            loading.close()
            this.$toast.fail(rej)
          })
      },
      //提交表单后跳转列表
      successGoList() {
        switch (Number(this.workflowType)) {
          case -1:
            this.$router.push(`/office-automation/currency?createId=${this.$route.query.templateId}`)
            break
          case 10:
            this.$router.push(`/office-automation/working-journal?createId=${this.$route.query.templateId}`)
            break
          case 20:
            this.$router.push(`/office-automation/administrative/my-assets?createId=${this.$route.query.templateId}`)
            break
          case 30:
            this.$router.push(`/office-automation/financing?createId=${this.$route.query.templateId}`)
            break
        }
      },
      //重置表单
      resetForm() {
        this.successGoList()
      },
      //审批流程人员的数据处理
      personDispose(item) {
        if (item.children) {
          item.children.forEach(child => {
            if (child.value) {
              this.parallelData.push(child)
            }
            this.personDispose(child)
          })
        }
      },
      //在平行数据中找到对应的数据
      getPersonDate(id, flag = false) {
        this.parallelData.forEach(item => {
          if (id === item.value) {
            if (flag) {
              item.disabled = true
            }
            let obj =
              {
                userId: item.value,
                userName: item.label
              }
          }
        })
      },
      //递归添加树形结构
      optionsTree(obj, item, index) {
        if (item.companyUserList) {
          item.companyUserList.forEach(person => {
            let user = {
              value: person.userId,
              label: person.bizName,
              disabled: false,
              hierarchy: index
            }
            obj.children.push(user)
          })
        }
      },
      optionsDev(obj, item, index) {
        if (item.sonList) {
          item.sonList.forEach(son => {
            let children = {
              value: '',
              label: son.deptName,
              disabled: false,
              children: [],
              deptIndex: index
            }
            index++
            this.optionsDev(children, son, index)
            this.optionsTree(children, son, index)
            obj.children.push(children)
          })
        } else {
          return false
        }
      },
      //处理人员
      handlePerson(type, infoType, flag) {
        /*if (this.typeQuery === 'view'){
          if (this.valueDetailsList[infoType].length === this.parallelData.length){
            type === 'ccUsers' ? this.ccUsersViewAll = true : this.auditViewAll = true
          }
          this.valueDetailsList[infoType].forEach(item => {
            let obj = {
              userId: type === 'ccUsers' ? item.ccUserId : item.auditUserId,
              userName: type === 'ccUsers' ? item.ccUserName : item.auditUserName,
              id: item.id,
            }
            if (type === 'auditUsers'){
              obj.auditResult = item.auditResult
            }
            this.formInfo.auditInfo[type].push(obj)
          })
        }else{

        }*/
        if (flag) {
          let arr = [], arr1 = []
          if (this.addAssetDate.myAuditConfig) {
            if (this.addAssetDate.myAuditConfig[type]) {
              this.addAssetDate.myAuditConfig[type].forEach(item => {
                arr.push(item.userId)
              })
            }
          }
          this.valueDetailsList[infoType].forEach(item => {
            type === 'ccUsers' ? arr1.push(item.ccUserId) : arr1.push(item.auditUserId)
          })
          //取数组中重复的
          let arrSame = _.intersection(arr, arr1)
          //数组去重
          let arrBoth = _.xor(arr, arr1)
          this.valueDetailsList[infoType].forEach(item => {
            arrBoth.forEach(arr => {
              if (type === 'ccUsers' ? item.ccUserId === arr : item.auditUserId === arr) {
                let obj = {
                  userId: type === 'ccUsers' ? item.ccUserId : item.auditUserId,
                  userName: type === 'ccUsers' ? item.ccUserName : item.auditUserName
                }
                if (type === 'auditUsers') {
                  obj.auditResult = item.auditResult
                }
                this.formInfo.auditInfo[type].push(obj)
              }
            })
          })
          /* if (type === 'auditUsers'){
             let auditArr = []
             this.valueDetailsList.auditUserList.forEach(item => {
               arrSame.forEach(arr => {
                 let auditUsers = {
                   userId: item.auditUserId,
                   userName: item.auditUserName,
                   auditResult: item.auditResult
                 }
                 auditArr.push(auditUsers)
               })
             })
             this.addAssetDate.myAuditConfig.auditUsers = auditArr
           }*/
        } else {
          this.valueDetailsList[infoType].forEach(item => {
            let obj = {
              userId: type === 'ccUsers' ? item.ccUserId : item.auditUserId,
              userName: type === 'ccUsers' ? item.ccUserName : item.auditUserName
            }
            if (type === 'auditUsers') {
              obj.auditResult = item.auditResult
            }
            this.formInfo.auditInfo[type].push(obj)
          })
        }
      },
      //获取部门树形结构
      async getDepartmentTreeInfo() {
        this.approver = []
        let obj = {
          value: this.currentCompanyName
        }
        let loading = this.$loading({'target': 'body'})
        await this.$httpV3.post('user/company/dept/list/tree/user', obj)
          .then(res => {
            loading.close()
            if (Number(res.data.code) === 10000) {
              let data = res.data.data
              if (data) {
                data.forEach((item, index) => {
                  let objTree = {
                    value: '',
                    label: item.deptName,
                    children: []
                  }
                  this.optionsDev(objTree, item, index)
                  this.optionsTree(objTree, item, index)

                  this.approver.push(objTree)
                })
                this.defaultCompanyPersonList = this.Unbind(data)
                this.companyPersonList = data
                this.companyPersonList.forEach(item => {
                  item.sonListBlock = true
                })
                this.defaultCompanyPersonList.forEach(item => {
                  item.sonListBlock = true
                })
                this.approver.forEach(item => {
                  this.personDispose(item)
                })
                //初始化数据
                this.initAssetData()
              }
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(rej => {
            loading.close()
          })
      },
      //处理工作流详情数据(查看)
      handleTemplateViewDetails() {
        this.formInfo.fieldList = []
        this.valueDetailsList.fieldList.forEach(item => {
          if (Number(item.fieldType) === 10) {
            switch (Number(item.fieldCategory)) {
              case 10:
                this.valueDetailsList.valueList.forEach(single => {
                  if (item.id === single.workflowFieldId) {
                    item.fileText = item.fieldValue
                    this.formInfo.fieldList.push(item)
                  }
                })
                break
              case 20:
                this.valueDetailsList.valueList.forEach(img => {
                  if (item.id === img.workflowFieldId) {
                    item.fileText = JSON.parse(item.fieldValue)

                    item.imgDesc = item.fileText
                    this.formInfo.fieldList.push(item)
                  }
                })
                break
              case 30:
                this.valueDetailsList.valueList.forEach(filed => {
                  if (item.id === filed.workflowFieldId) {
                    let obj = JSON.parse(item.fieldValue)
                    item.filedInfo = obj.fileUrl
                    item.filedName = obj.fileName
                    item.filedSize = obj.fileSize
                    item.filedArr = [item.filedInfo]
                    this.formInfo.fieldList.push(item)
                  }
                })
                break
              case 40:
                this.valueDetailsList.valueList.forEach(radio => {
                  if (item.id === radio.workflowFieldId) {
                    item.fileText = item.fieldValue
                    if (typeof item.fieldSelectorConfig === 'string') {
                      item.fieldSelectorConfig = JSON.parse(item.fieldSelectorConfig)
                    }
                    this.formInfo.fieldList.push(item)
                  }
                })
                break
              case 50:
                this.valueDetailsList.valueList.forEach(check => {
                  if (item.id === check.workflowFieldId) {
                    if (typeof item.fieldValue === 'string') {
                      item.fileText = JSON.parse(item.fieldValue)
                    }
                    if (typeof item.fieldSelectorConfig === 'string') {
                      item.fieldSelectorConfig = JSON.parse(item.fieldSelectorConfig)
                    }
                    this.formInfo.fieldList.push(item)
                  }
                })
                break
              case 60:
                this.valueDetailsList.valueList.forEach(date => {
                  if (item.id === date.workflowFieldId) {
                    if (item.fieldDesc === 'date') {
                      item.fileText = new Date(Number(item.fieldValue)).getTime().toString().timeStampFormat('yyyy-MM-dd')
                      this.formInfo.fieldList.push(item)
                    } else {
                      item.fileText = new Date(Number(item.fieldValue)).getTime().toString().timeStampFormat()
                      this.formInfo.fieldList.push(item)
                    }
                  }
                })
                break
            }
          }
        })
        this.handlePerson('auditUsers', 'auditUserList', false)
        this.handlePerson('ccUsers', 'ccUserList', false)
      },
      //处理工作流详情数据(编辑 重新提交)
      handleTemplateDetails() {
        let isTips = true
        this.valueDetailsList.fieldList.forEach(item => {
          if (Number(item.fieldType) === 10) {
            switch (Number(item.fieldCategory)) {
              case 10:
                this.formInfo.fieldList.forEach(single => {
                  if (item.workflowTemplateFieldId === single.id) {
                    //替换所有的换行符
                    let string = item.fieldValue
                    string = string.replace(/<br>/g, '\r\n');
                    string = string.replace(/<br>/g, '\n');
                    //替换所有的空格（中文空格、英文空格都会被替换）
                    item.fieldValue = string.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g, ' ');
                    isTips = false
                    single.fileText = item.fieldValue
                  }
                })
                break
              case 20:
                this.formInfo.fieldList.forEach(img => {
                  if (item.workflowTemplateFieldId === img.id) {
                    isTips = false
                    if (item.fieldValue) {
                      img.fileText = JSON.parse(item.fieldValue)
                    }
                    img.imgDesc = img.fileText
                  }
                })
                break
              case 30:
                this.formInfo.fieldList.forEach(filed => {
                  if (item.workflowTemplateFieldId === filed.id) {
                    isTips = false
                    if (item.fieldValue) {
                      let obj = JSON.parse(item.fieldValue)
                      filed.filedInfo = obj.fileUrl
                      filed.filedName = obj.fileName
                      filed.filedSize = obj.fileSize
                      filed.filedArr = [filed.filedInfo]
                    }
                  }
                })
                break
              case 40:
                this.formInfo.fieldList.forEach(radio => {
                  if (item.workflowTemplateFieldId === radio.id) {
                    isTips = false
                    radio.fileText = item.fieldValue
                    let arr = []
                    if (item.fieldSelectorConfig && radio.checkBoxList) {
                      JSON.parse(item.fieldSelectorConfig).forEach(field => {
                        let obj = {
                          label: field
                        }
                        arr.push(obj)
                      })
                      radio.checkBoxList = arr
                    }
                  }
                })
                break
              case 50:
                this.formInfo.fieldList.forEach(check => {
                  if (item.workflowTemplateFieldId === check.id) {
                    isTips = false
                    if (item.fieldValue) {
                      check.fileText = JSON.parse(item.fieldValue)
                    }
                    let arr = []
                    if (item.fieldSelectorConfig && check.checkBoxList) {
                      JSON.parse(item.fieldSelectorConfig).forEach(field => {
                        let obj = {
                          label: field
                        }
                        arr.push(obj)
                      })
                      check.checkBoxList = arr
                    }
                  }
                })
                break
              case 60:
                this.formInfo.fieldList.forEach(date => {
                  if (item.workflowTemplateFieldId === date.id) {
                    isTips = false
                    if (item.fieldDesc === 'date') {
                      date.fileText = new Date(Number(item.fieldValue)).getTime().toString().timeStampFormat('yyyy-MM-dd')
                    } else {
                      date.fileText = new Date(Number(item.fieldValue)).getTime().toString().timeStampFormat()
                    }
                  }
                })
                break
            }
          }
        })
        this.handlePerson('auditUsers', 'auditUserList', true)
        this.handlePerson('ccUsers', 'ccUserList', true)

        if(isTips){
          const h = this.$createElement;
          this.$msgbox({
            title: '',
            message: h('div', null, [ h('div', {class: 'cancel icon'}), h('div', null, '模板已更改，请撤销后新增,点击确定返回')]),
            customClass: 'custom-msg-box',
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            closeOnHashChange: false,
            confirmButtonText: '确定',
            confirmButtonClass: 'btn-danger waves-effect'
          })
            .then(() => {
              this.successGoList()
            })
        }
      },
      //判断去哪个列表
      judgeList() {
        switch (Number(this.workflowType)) {
          case -1:
            this.listName = '通用列表'
            break
          case 10:
            this.listName = '日志列表'
            break
          case 20:
            this.listName = '资产列表'
            break
          case 30:
            this.listName = '财务列表'
            break
        }
      }
    },
    async created() {
      //获取部门树形结构
      await this.getDepartmentTreeInfo()
      if (this.valueDetailsList) {
        if (this.typeQuery === 'view' || this.typeQuery === 'approval') {
          //处理工作流详情数据(查看)
          await this.handleTemplateViewDetails()
        } else {
          //处理工作流详情数据(编辑 重新提交)
          await this.handleTemplateDetails()
        }
      }
      await this.judgeList()
      /*this.$bus.$on('onSubmit', (values) => {
        this.handleFormInfo()
      })*/
    }
  }
</script>

<style lang="stylus" type="text/stylus">

  .form-wrap {
    .auditConfig-list {
      .add-carbon-copy-recipients {
        display flex
        justify-content center
        align-items center
        margin-left 0px

        .iconfont {
          font-size 0.2rem
          color #999
          cursor pointer
        }
      }
      .all-person {
        width: 0.45rem;
        height: 0.45rem;
        margin-bottom: 0.05rem;
        border: 0.01rem solid #999;
        border-radius: 0.1rem
        display inline-flex
        justify-content center
        align-items center
        position: relative;
        margin-right: 0.05rem;
      }
      .person {
        display inline-flex
        justify-content center
        width: 0.45rem;
        height: 0.45rem;
        margin-bottom: 0.05rem;
        border-radius: 0.1rem
        line-height: 0.45rem;
        position: relative;
        margin-right: 0.05rem;
        background-color #ececec
        &.approver-success {
          background-color #00c875
          color #fff
        }
        &.approver-reject {
          background-color #f73859
          color #fff
        }
        &.approver-wait {
          background-color #e6a23c
          color #fff
        }

        .person-name {
          font-size 0.12rem
          white-space nowrap
          overflow hidden
          text-overflow ellipsis
        }

        .close-icon {
          position absolute
          right -0.05rem
          top -0.2rem
          cursor pointer

          i {
            display inline-flex
            align-items center
            justify-content center
            width 0.15rem
            height 0.15rem
            font-size 0.18rem
            padding 0.05rem
            opacity .6
            /*background-color rgba(0,0,0,.6)*/
            /* color #ffffff*/
          }
        }

        &:hover {

          .close-icon {
            display inline-block
          }

        }
      }
      .add-wrap {
        display flex

        .person-wrap {
          display flex
          flex-wrap wrap
          max-width 2.5rem
          .person-arrow-wrap{
            display flex
            align-items center

          }
          .person-block {
            display flex
            flex-wrap wrap
          }

        }
      }

    }

    .van-checkbox-group {
      .van-checkbox {
        margin-bottom 0.05rem
      }
    }

    .van-field {
      .van-cell__value {
        .el-link {
          color #fff
          padding 0.05rem
        }

        .van-uploader {
          .van-uploader__wrapper {
            align-items center

            .van-uploader__input-wrapper {
              display flex
              align-items center

              .van-tag {
                padding 0.05rem
                margin-left 0.1rem
              }
            }
          }

        }
      }
    }

    .demo-ruleForm {
      .warning {
        color #e6a23c
      }
      .spu-pic-info {
        display flex
        flex-wrap wrap

        .image-list {
          display inline-flex
          align-items center
          justify-content center
          width 0.8rem
          height 0.8rem
          border 0.01rem solid #ddd
          position: relative;
          vertical-align top
          margin-right 0.05rem
          border-radius 0.05rem
          margin-bottom 0.05rem

          .close-icon {
            display inline-block
            position absolute
            right 0
            top -0.18rem
            cursor pointer

            i {
              display inline-block
              padding: 0.05rem
              opacity: 0.6
              width: 0.15rem
              height: 0.15rem
              text-align center
              font-size 0.18rem
            }
          }
        }

        .add-btn-wrap {
          display inline-flex
          align-items center

          .add-btn {
            display inline-flex
            align-items center
            justify-content center
            width 200px
            height 160px
            border 1px solid #ddd
            position: relative;
            vertical-align top
            margin-right 15px

            .iconfont {
              color #999
              font-size 28px
            }
          }
        }

      }

      .form-btn {
        padding 0.1rem 0
        margin-top 0.2rem
        text-align center
        .van-button {
          padding 0 0.15rem
          font-size 0.14rem
          height 0.32rem
          border-radius 0.02rem
          margin-right 0.1rem
        }
      }
      .el-radio-group {
        height 28px
        display inline-flex
        align-items center
        margin-right 10px
      }

      .el-checkbox-group {
        margin-right 10px
      }

      .accessory-tag {
        margin-right 5px
      }

      /*.accessory-tag{
        display flex

        .accessory{
          display block
        }
      }*/

    }

    .supplier-channel-dialog {
      background #ececec
      .van-nav-bar {
        height 0.46rem
        line-height 0.46rem
        .van-nav-bar__content {
          width 100%
          background-color #4d8fff
          font-size 0.14rem
          height 0.46rem
          .van-nav-bar__left {
            padding 0 0.16rem
            font-size 0.14rem
            .van-nav-bar__text, .van-icon {
              margin-right 0.04rem
              font-size 0.16rem
              color #fff
            }
          }
          .van-nav-bar__title {
            color #fff
            font-size 0.16rem
          }
        }
      }

      .header-crumbs {
        background-color #fff
        max-width 100%
        .el-breadcrumb {
          overflow-x auto
          overflow-y hidden
          width auto
          height 0.56rem
          font-size 0.16rem
          white-space nowrap
          background-color #fff
          line-height normal
          padding 0 0.1rem
          display flex
          &::-webkit-scrollbar {
            display: none;
          }

          .el-breadcrumb__item {
            padding-top 0.2rem
          }
          .active-breadcrumb {
            .el-breadcrumb__inner {
              color #466fff
              font-weight bold
            }
          }
        }
      }
      .content-wrap {
        position absolute
        width 100%
        height calc(100% - 0.46rem - 0.56rem - 0.78rem)
        overflow-y auto
        .van-cell-group {
          &.check-all {
            margin-top 0.1rem
          }
        }
        .title {
          font-size 0.18rem
          color #3960f4
          font-weight bold
          padding 0.1rem
          margin-top 0.1rem
        }
        .van-cell-group {
          .supplier-channel-dialog-cell {
            align-items center
            font-size 0.14rem
            line-height 0.24rem
            padding 0.1rem 0.16rem
            .person-tit {
              display flex
              align-items center
            }
            .auditConfig-list {
              display inline-flex
              align-items center
              justify-content center
              .person-name {
                width: 0.45rem;
                height: 0.45rem;
                border-radius: 0.1rem
                text-align: center;
                line-height: 0.45rem;
                position: relative;
                background-color #ececec
              }
            }

            .next-department {
              font-size 0.12rem
              .iconfont {
                font-size 0.12rem
              }
            }
            .title-wrap {
              display flex
              align-items center

              .custom-title {
                margin-left 0.05rem
                font-size 0.14rem
              }
            }
          }

          .custom-image {
            .van-empty__image {
              width 1rem
              height 1rem
            }
            .van-empty__description {
              margin-top 0.16rem
              padding 0 0.6rem
              font-size 0.14rem
              line-height 0.2rem
            }
          }
        }
        .person-cell-wrap {
          display flex
          align-items center
          .person-cell-radio {
            margin-left 0.1rem
          }
        }

        .auditUserPerson {
          margin-top 0.5rem

        }

        .el-cascader-panel {
          flex-wrap wrap
        }

      }
      .footer-wrap {
        position: fixed;
        bottom 0
        left 0
        width 100%
        box-shadow: 0.02rem 0 0.09rem #888888;
        background-color #fff
        padding 0.2rem 0.1rem
        display flex
        justify-content space-between
        .select-person {
          font-size 0.12rem
          .select-tit {
            color #3960f4
            font-size 0.14rem
            font-weight bold
          }
          .van-action-sheet {
            height 50%
            .van-action-sheet__header {
              text-align left
              padding-left 0.1rem
              font-size 0.16rem
              line-height 0.48rem
              font-weight bold
            }
            .content {
              padding 0.1rem
            }
          }
          .person-name-wrap {
            max-width 2.8rem
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap
          }
        }
        .el-button {
          font-size 0.14rem
          padding 0.06rem 0.15rem
          border-radius 0.04rem
        }
      }
    }

    .approve-dialog {
      .title-wrap {
        font-size 0.14rem
        font-weight bold
      }
      .approve-bth-wrap {
        display flex
        align-items center
        justify-content center
        margin-bottom 0.2rem
        &:after {
          border-width 0
        }
        .el-button, .van-button {
          padding 0.07rem 0.15rem
          font-size 0.12rem
          border-radius 0.03rem
          border-width 0.01rem
          line-height 1
          height auto
          margin-right 0.3rem
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/office-automation/administrative/assetForm.vue